import { computed, type ComputedRef } from 'vue';
import { useRoute } from 'vue-router';

import { collectDirectoryRouteLocationSegments } from '@/helpers/Directory/directoryLocationValidation';

/**
 * Location segments for new Agency SRP and Agent SRP routes.
 * Invalid path/`loc` values throw PAGE_NOT_FOUND (legacy agency page does not use this).
 */
export const useDirectoryRouteLocations = (): ComputedRef<string[]> => {
  const route = useRoute();

  return computed(() =>
    collectDirectoryRouteLocationSegments(route.params.location, route.query.loc),
  );
};
